import { ApplicationConfig, importProvidersFrom, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UrlSerializer } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';

import { routes } from './app.routes';
import { JwtHttpInterceptor } from './shared/interceptors/jwt-http.interceptor';
import { LowerCaseUrlSerializer } from './shared/utilities/lowercase-url-serializer';
import { AuthService } from './shared/services/auth.service';
import { UtilityService } from './shared/services/utilities.service';
import { UserService } from './shared/services/user.service';
import { ProductService } from './product/product.service';
import { CourseService } from './course/course.service';
import { LessonService } from './lesson/lesson.service';
import { TestService } from './test/test.service';
import { MasterService } from './shared/services/master.service';
import { ValidatorService } from './shared/services/validator.service';
import { AuthGuard } from './shared/guards/auth-guard.service';
import { MasterGuard } from './shared/guards/master-guard.service';
import { RoleGuard } from './shared/guards/role-guard.service';
import { LicenseGuard } from './shared/guards/license.guard';
import { AppConfigService } from './shared/services/app-config.service';
import { CertificateService } from './shared/services/certificate.service';
import { Jwt } from './shared/utilities/constants';
import { ENV_CONFIG } from './environment.config';
import { environment } from '../environments/environment';

export function getToken() {
  return localStorage.getItem(Jwt.TOKEN_ID);
}

const jwtConfig = {
  config: {
    tokenGetter: getToken,
    blacklistedRoutes: ['authenticate', 'api/token'],
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(JwtModule.forRoot(jwtConfig)),
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
    { provide: HTTP_INTERCEPTORS, useClass: JwtHttpInterceptor, multi: true },
    { provide: ENV_CONFIG, useValue: environment },
    AuthGuard,
    MasterGuard,
    RoleGuard,
    AuthService,
    UtilityService,
    UserService,
    ProductService,
    CourseService,
    LessonService,
    TestService,
    MasterService,
    ValidatorService,
    LicenseGuard,
    AppConfigService,
    CertificateService,
  ],
};
